import { render, staticRenderFns } from "./freeOpen.vue?vue&type=template&id=33afe70f&scoped=true"
import script from "./freeOpen.vue?vue&type=script&lang=js"
export * from "./freeOpen.vue?vue&type=script&lang=js"
import style0 from "./freeOpen.vue?vue&type=style&index=0&id=33afe70f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33afe70f",
  null
  
)

export default component.exports